import { z } from 'zod';
import { SchemaDate } from '@axiom/types';

export const EnvoyCandidateProfileTopFocusAreaExperienceSchema = z.object({
  client: z.string(),
  startDate: SchemaDate,
  endDate: SchemaDate.nullable(),
  isAxiom: z.boolean(),
});

export type EnvoyCandidateProfileTopFocusAreaExperience = z.infer<
  typeof EnvoyCandidateProfileTopFocusAreaExperienceSchema
>;

export const EnvoyCandidateProfileTopFocusAreaSchema = z.object({
  focusArea: z.string(),
  yearsOfExperience: z.number(),
  experiences: z.array(EnvoyCandidateProfileTopFocusAreaExperienceSchema),
});

export type EnvoyCandidateProfileTopFocusArea = z.infer<
  typeof EnvoyCandidateProfileTopFocusAreaSchema
>;

export const EnvoyCandidateProfileTopFocusAreasSchema = z.object({
  topFocusAreas: z.array(EnvoyCandidateProfileTopFocusAreaSchema),
});

export type EnvoyCandidateProfileTopFocusAreas = z.infer<
  typeof EnvoyCandidateProfileTopFocusAreasSchema
>;
